import { genericMemo, Heading, Text } from "@overmap-ai/blocks"
import { submittedAtModelSortFn } from "@overmap-ai/common"
import { useMemo } from "react"

import { FieldsRevisionsTimelineItem } from "./FieldsRevisionsTimelineItem"
import type { FieldsRevisionModel } from "./typings"

interface FieldsRevisionsTimelineProps<TModel extends FieldsRevisionModel> {
	fieldsRevisions: TModel[]
	onRevisionSelect: (fieldsRevision: TModel) => void
}

export const FieldsRevisionsTimeline = genericMemo(function <TModel extends FieldsRevisionModel>(
	props: FieldsRevisionsTimelineProps<TModel>,
) {
	const { fieldsRevisions, onRevisionSelect } = props

	const sortedFieldsRevisions = useMemo(
		() => fieldsRevisions.toSorted(submittedAtModelSortFn).toReversed(),
		[fieldsRevisions],
	)

	return (
		<section className="flex w-full flex-col gap-4">
			<Heading size="sm" accentColor="base">
				Timeline
			</Heading>

			{sortedFieldsRevisions.length > 0 ? (
				<div className="flex w-full flex-col gap-4">
					{sortedFieldsRevisions.map((fieldsRevision) => (
						<FieldsRevisionsTimelineItem
							key={fieldsRevision.uuid}
							fieldsRevision={fieldsRevision}
							onSelect={onRevisionSelect}
						/>
					))}
				</div>
			) : (
				<Text size="sm" accentColor="base">
					No field revisions yet.
				</Text>
			)}
		</section>
	)
})
